import { Injectable, signal } from '@angular/core';
import { AuthProfile, OrgContext } from './auth-profile.model';

/**
 * Session-scoped holder for the signed-in user's profile and the active
 * organization (FDD §4.2). In-memory only — it resets on a full page reload, so
 * the org guard re-resolves (and re-prompts multi-org users) on every app load.
 * The active org feeds UserContext for the shell in a later ticket.
 */
@Injectable({ providedIn: 'root' })
export class OrgContextService {
  private readonly _profile = signal<AuthProfile | null>(null);
  private readonly _activeOrg = signal<OrgContext | null>(null);

  readonly profile = this._profile.asReadonly();
  readonly activeOrg = this._activeOrg.asReadonly();

  setProfile(profile: AuthProfile): void {
    this._profile.set(profile);
  }

  setActiveOrg(org: OrgContext): void {
    this._activeOrg.set(org);
  }

  clear(): void {
    this._profile.set(null);
    this._activeOrg.set(null);
  }
}
